enum FaqActions {
  FETCH_LIST = "faqFetchList",
  GET_ITEM = "faqGetItem",
  CREATE_ITEM = "faqCreateItem",
  UPDATE_ITEM = "faqUpdateItem",
  DELETE_ITEM = "faqDeleteItem",
  UPDATE_TRANSLATION = "faqUpdateTranslation",
  REFRESH_LIST = "faqRefreshList",
  GET_GROUP_TREE = "faqGetGroupTree",
  ASSIGN_TO_GROUP = "faqAssignToGroup",
  REMOVE_FROM_GROUP = "faqRemoveFromGroup",
  REORDER_GROUP = "faqReorderGroup",
}

enum FaqMutation {
  SET_RENDER_UPDATE = "faqListRenderNeeded",
  SET_LIST_RESULT = "faqListResult",
  SET_ACTIVE_TYPE = "faqActiveType",
}

export { FaqActions, FaqMutation };
